var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill flex-box col",class:!_vm.max_flag?'max-body-width':''},[_vm._t("header"),_vm._v(" "),(!_vm.$slots.body)?_c('div',{staticClass:"flex-box-bd fullw tleft",staticStyle:{"overflow-y":"auto","overflow-x":"hidden","padding":"0 5px"}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5d607e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myPage.vue
// module id = null
// module chunks = 